import actionWebInvoke from '../../utils/actionCallUtils';
import actions from '../../config.json';
import OBJCODE from '../../constants';

async function getWfFoldersAndFiles(objCode, objID) {
  const fields = [
    'name',
    'lastModDate',
    'linkedFolderID',
    'enteredByID',
    'linkedFolder:*',
    'parentID',
    'documents:name',
    'documents:currentVersionID',
    'documents:lastModDate',
    'documents:downloadURL',
    'documents:previewURL',
    'documents:versions:*',
    'children:name',
    'children:enteredByID',
    'children:lastModDate',
    'children:linkedFolderID',
    'children:linkedFolder:*',
    'children:parentID',
  ];
  let queryParams;
  if (objCode === 'PROJ') {
    queryParams = {
      projectID: objID,
    };
  } else if (objCode === 'TASK') {
    queryParams = {
      taskID: objID,
    };
  } else if (objCode === 'ISSUE') {
    queryParams = {
      issueID: objID,
    };
  }
  const actionResponse = await actionWebInvoke(
    actions['workfront-action'],
    {},
    { objCode: OBJCODE.DOC_SEARCH, queryParams, fields },
  );
  return actionResponse;
}

async function createProof(ID, documentVersionID) {
  const fields = [];
  const queryParams = {
    ID,
    documentVersionID,
    method: 'put',
  };

  const actionResponse = await actionWebInvoke(
    actions['workfront-action'],
    {},
    { objCode: OBJCODE.CREATE_PROOF, queryParams, fields },
  );
  return actionResponse;
}

async function createFolderInWF(name, objCode, objID, parentID) {
  // If empty parentID, folder created directly under documents in a particular object
  const fields = [];
  let queryParams;
  if (objCode === 'PROJ') {
    queryParams = {
      name,
      projectID: objID,
      parentID,
      method: 'post',
    };
  } else if (objCode === 'TASK') {
    queryParams = {
      name,
      taskID: objID,
      parentID,
      method: 'post',
    };
  } else if (objCode === 'ISSUE') {
    queryParams = {
      name,
      issueID: objID,
      parentID,
      method: 'post',
    };
  }
  const actionResponse = await actionWebInvoke(
    actions['workfront-action'],
    {},
    { objCode: OBJCODE.DOC_CREATE, queryParams, fields },
  );
  return actionResponse;
}

// Source: https://stackoverflow.com/a/29202760
function chunkSubstr(str, size) {
  const numChunks = Math.ceil(str.length / size);
  const chunks = new Array(numChunks);

  for (let i = 0, o = 0; i < numChunks; ++i, o += size) {
    chunks[i] = str.substr(o, size);
  }

  return chunks;
}

const toBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

async function uploadToWfAndGetHandle(file) {
  const fileName = file.name;
  const filebase64 = await toBase64(file);
  const base64 = filebase64.split(',')[1];

  const chunkSize = 900000; // Send 900KB Chunks
  const chunks = chunkSubstr(base64, chunkSize);

  let handleResponse;
  if (chunks.length) {
    let uploadedChunks = 0;
    const upload = async i => {
      handleResponse = await actionWebInvoke(
        actions['workfront-project-upload-handle'],
        {},
        {
          fileName,
          chunk: chunks[i],
          totalChunks: chunks.length,
          chunkIndex: i,
        },
      );
      // const res = await handleResponse.json();
      if (handleResponse.data) {
        console.log(
          `All ${chunks.length} chunks uploaded successfully !`,
          handleResponse.data,
        );
      } else {
        uploadedChunks++;
        console.log(
          `Uploaded chunk ${uploadedChunks}/${chunks.length} ...`,
          handleResponse,
        );
      }
    };

    console.log('chunks length', chunks.length);
    const concurrency = 25;
    const batches = Math.ceil(chunks.length / concurrency);
    console.log('number of batches', batches);
    for (let b = 0; b < batches; b++) {
      const uploadPromises = [];
      for (let c = 0; c < concurrency; c++) {
        const index = b * concurrency + c;
        // check this whether chunks.length -1 or not
        if (index < chunks.length - 1) {
          uploadPromises.push(upload(index));
        }
      }

      if (uploadPromises.length) {
        await Promise.all(uploadPromises);
      }
    }

    console.log(`Preparing file ...`);
    await upload(chunks.length - 1);
  }

  return handleResponse;
}

async function uploadToFolderInWF(file, docObjCode, objID, folderIDs) {
  const handleResponse = await uploadToWfAndGetHandle(file);
  console.log('handleResponse.handle logs', handleResponse);
  const queryParams = {
    method: 'post',
    // docObjCode can be OPTASK, PROJ, TASK and objID to
    // objID would be Request ID, Project ID or Task ID
    // updates: `{"name":"${file.name}","handle":"${handleResponse.data.handle}","docObjCode":"PROJ","objID":"60c94b6000281f78f8b1db441e5d8528"}`,
    updates: `{name:"${file.name}",handle:"${handleResponse.data.handle}",docObjCode:"${docObjCode}",objID:"${objID}",folderIDs:${folderIDs}}`,
  };

  const actionResponse = await actionWebInvoke(
    actions['workfront-action'],
    {},
    {
      queryParams,
      objCode: OBJCODE.DOCUMENT_UPLOAD,
    },
  );
  console.log('Doc upload response in project brief', actionResponse);
}

export {
  getWfFoldersAndFiles as default,
  createProof,
  createFolderInWF,
  uploadToFolderInWF,
};
